<pr-chat-list [preventRouteChange]="true" (chatSelected)="showChat($event)" />
<mat-divider />
<a
  class="m-2"
  mat-button
  mat-dialog-close
  color="primary"
  [prPracticeRouterLink]="['chats']"
  >See all in Team Chats</a
>
